import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const PayPerClickAdvertising = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/dedicated-dev-2.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                    <h1 id="heading_line">The Ultimate Guide to Pay-Per-Click Advertising (PPC)</h1>
                    <h2 id="sub_heading1">
                    In today's competitive digital landscape, businesses need effective strategies to drive traffic and generate leads. Pay-Per-Click (PPC) advertising is one of the most powerful tools for achieving instant visibility and reaching targeted audiences. Whether you're a small business owner or a digital marketer, understanding how to leverage PPC can significantly enhance your online presence and maximize conversions.
                    </h2>                                    
                </div>
              </div>
            </div>
            </div>
            <div className="why_coustom_app">
                <div className="wrapper">
                <h3>What is <span>PPC?</span> </h3>
                    <p>Pay-Per-Click (PPC) advertising is a digital marketing model where advertisers pay a fee each time their ad is clicked. Instead of earning organic traffic through SEO, PPC allows businesses to buy visits by bidding on keywords related to their products or services. Platforms like Google Ads, Bing Ads, and social media channels (Facebook, Instagram, LinkedIn) offer PPC advertising opportunities.</p>

                    <h3>Benefits of <span>PPC Advertising</span></h3>
                    <p>PPC advertising offers numerous advantages, making it a crucial digital marketing strategy for businesses looking to enhance their online presence. One of the key benefits is instant visibility, as PPC ads appear at the top of search engine results, driving immediate traffic to a website. Additionally, PPC enables businesses to target specific audiences based on location, demographics, and user behavior, ensuring that ads reach the right people at the right time. The return on investment (ROI) is measurable, allowing advertisers to track metrics such as cost-per-click (CPC), conversion rates, and return on ad spend (ROAS) for better decision-making. Another significant advantage is budget control, as businesses can set daily or monthly spending limits to optimize their ad spend. Even if users do not click on the ads, PPC helps boost brand awareness by increasing visibility on search engine results pages, ensuring that potential customers become familiar with the brand over time.</p>
					<h3>Key <span>PPC Strategies</span></h3>
					<h4>1. Keyword Targeting & Bidding</h4>
					<ul>
						<li>Conduct in-depth keyword research using tools like Google Keyword Planner and SEMrush.</li>
						<li>Use different match types: broad match, phrase match, and exact match for optimization.</li>
						<li>Monitor and adjust bids to maximize ROI and control costs.</li>
					</ul>
					<h4>2. Ad Copy & Landing Page Optimization</h4>
					<ul>
						<li>Write compelling ad copy with strong CTAs (Call-To-Actions).</li>
						<li>Ensure landing pages are relevant, fast-loading, and mobile-friendly.</li>
						<li>A/B test different headlines, descriptions, and ad formats to improve performance.</li>
					</ul>
					<h4>3. PPC Budget Management</h4>
					<ul>
						<li>Set realistic budgets and adjust based on campaign performance.</li>
						<li>Use automated bidding strategies (maximize conversions, target ROAS, etc.).</li>
						<li>Track cost-per-click (CPC) and optimize for higher conversion rates.</li>
					</ul>
					<h4>4. Audience Targeting & Retargeting</h4>
					<ul>
						<li>Utilize demographic, geographic, and behavioral targeting.</li>
						<li>Implement retargeting ads to reach users who previously interacted with your website.</li>
						<li>Use lookalike audiences to find new potential customers similar to existing ones.</li>
					</ul>
					<h4>5. Performance Tracking & Optimization</h4>
					<ul>
						<li>Analyze key metrics: Click-Through Rate (CTR), Quality Score, and Conversion Rate.</li>
						<li>Optimize ad creatives, keywords, and bidding strategies based on performance data.</li>
						<li>Use A/B testing and experiment with different ad formats and placements.</li>
					</ul>
					<h3>PPC Trends to <span>Watch in 2024</span></h3>
					<ul>
						<li><strong>AI & Automation </strong>- Smart bidding and AI-driven ad campaigns for improved efficiency.</li>
						<li><strong>Voice Search Optimization</strong> – PPC ads tailored for voice search queries.</li>
						<li><strong>Video Ads Growth </strong>– Increased use of video ads on platforms like YouTube and social media.</li>
						<li><strong>First-Party Data Usage </strong>– Adapting to data privacy changes with customer-centric targeting.</li>
						<li><strong>Interactive & Visual Search Ads </strong>– Google and social media integrating more visual ad formats.</li>
					</ul>
					<h3>Conclusion</h3>
					<p>PPC advertising is a dynamic and cost-effective way to drive targeted traffic and increase conversions. By implementing the right strategies, optimizing ads, and staying updated with industry trends, businesses can achieve high ROI and long-term success in their digital marketing efforts.</p>
					<h3>Need Help with<span> PPC?</span></h3>
					<p>you want to maximize your ad performance and generate more leads, contact us for professional PPC management services!</p>
                </div>
            </div>
            <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
            </div>
            <div className="let_build">
                <div className="wrapper">
                <h4>Let’s Build <span> Your App Together </span></h4>
                
                <p>
                Whether you’re a startup looking to disrupt the market or an
                established enterprise aiming to enhance operational efficiency,
                CodeFlix is here to bring your vision to life. Let’s create a
                custom mobile app that drives results and delights your users.{" "}
                <br />
                Contact Us today to get started on your mobile app development
                journey.
                </p>
                </div>
            </div>
        </>
      );
};
export default PayPerClickAdvertising;
